<div class="relatorio content">
  <div
    class="card card-outline"
    [ngClass]="{ 'break-before': i !== 0 }"
    *ngFor="let matriz of lista; let i = index"
  >
    <div class="card-body">
      <div class="titulo-matriz no-break">
        <h4>Unidade Gestora: {{ matriz.unidadeGestora?.nome }}</h4>
        <h4>Subtipo: {{ matriz.subtipoAuditoria?.nome }}</h4>
      </div>

      <div *ngFor="let subTipoMatriz of matriz.subtipoAuditoria.subtipoAuditoriaMatrizPlanejamento" class="matriz-container">
        <div class="titulo-matriz-section no-break keep-with-next">
          <h4>Matriz: {{ subTipoMatriz.matrizPlanejamento?.nome }}</h4>
        </div>

        <!-- Container da tabela com controle de quebra -->
        <div class="table-wrapper">
          <div class="table-container">
            <table class="matriz-tabela">
              <thead class="table-header">
              <tr>
                <th class="col-questao">QUESTÕES DE AUDITORIA</th>
                <th class="col-criterio">CRITÉRIO APLICÁVEL</th>
                <th class="col-constatacao">POSSÍVEIS CONSTATAÇÕES</th>
                <th class="col-procedimento">PROCEDIMENTOS</th>
                <th class="col-fonte">INFORMAÇÕES REQUERIDAS / FONTES</th>
                <th class="col-detalhamento">DETALHAMENTO DOS PROCEDIMENTOS</th>
                <th class="col-tecnica">TÉCNICAS</th>
              </tr>
              </thead>
              <tbody>
              <tr
                *ngFor="let questao of subTipoMatriz.matrizPlanejamento?.matrizPlanejamentoQuestaoPlanejamento; let idx = index"
                class="table-row"
                [ngClass]="{
                    'page-break-before': shouldBreakBefore(idx),
                    'avoid-break': !shouldBreakBefore(idx) && idx < 5
                  }"
              >
                <td class="col-questao">
                  <div class="cell-content">
                    <strong>Q. {{ questao.questao.ordem }}:</strong> {{ questao.questao.nome }}
                  </div>
                </td>
                <td class="col-criterio">
                  <div class="cell-content">
                    <span *ngIf="questao.questao.legislacaoAplicavelCriterio">{{ getTextoLimpo(questao.questao.legislacaoAplicavelCriterio) }}</span>
<!--                    <span *ngIf="questao.questao.legislacaoAplicavelCriterio" class="show-on-print">{{ getTextoLimpo(questao.questao.legislacaoAplicavelCriterio) }}</span>-->
                  </div>
                </td>
                <td class="col-constatacao">
                  <div class="cell-content">
                    <div *ngFor="let c of questao.questao.questaoConstatacao; index as i" class="constatacao-item">
                      <strong>C.{{ questao.questao.ordem }}.{{ i+1 }}:</strong> {{ c.constatacao.nome }}
                    </div>
                  </div>
                </td>
                <td class="col-procedimento">
                  <div class="cell-content">
                    <div *ngFor="let p of questao.questao.questaoProcedimentoAuditoria; index as i" class="procedimento-item">
                      <strong>P.{{ questao.questao.ordem }}.{{ i+1 }}:</strong> {{ p.procedimentoAuditoria.nome }}
                    </div>
                  </div>
                </td>
                <td class="col-fonte">
                  <div class="cell-content">
                    <div *ngFor="let p of questao.questao.questaoProcedimentoAuditoria" class="fonte-item">
                      <span>{{ getTextoLimpo(p.procedimentoAuditoria.fonteInformacao) }}</span>
<!--                      <span class="show-on-print">{{ getTextoLimpo(p.procedimentoAuditoria.fonteInformacao) }}</span>-->
                    </div>
                  </div>
                </td>
                <td class="col-detalhamento">
                  <div class="cell-content">
                    <div *ngFor="let p of questao.questao.questaoProcedimentoAuditoria; index as i" class="detalhamento-item">
                      <strong> P.{{ questao.questao.ordem }}.{{ i + 1 }}</strong>
                      <span>{{ getTextoLimpo(p.procedimentoAuditoria.detalhamentoProcedimento) }}</span>
                    </div>
                  </div>
                </td>
                <td class="col-tecnica">
                  <div class="cell-content">
                    <div *ngFor="let p of questao.questao.questaoProcedimentoAuditoria" class="tecnica-item">
                        <span *ngFor="let t of p.procedimentoAuditoria.procedimentoTecnicaAuditoria; let last = last">
                          <span class="show-on-screen">{{ getTextoLimpo(t.tecnicaAuditoria.nome) }}</span>
                          <span class="show-on-print">{{ getTextoLimpo(t.tecnicaAuditoria.nome) }}</span>
                          <br *ngIf="!last" class="show-on-screen" />
                          <br *ngIf="!last" class="show-on-print" />
                        </span>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Botões -->
    <div class="card-footer no-print">
      <button type="button" class="btn btn-default btn-sm mr-1" (click)="cancelar()">
        <i class="fas fa-times"></i> Fechar
      </button>
      <button type="button" class="btn btn-primary btn-sm mr-1" (click)="print()">
        <i class="fas fa-print"></i> Imprimir
      </button>
    </div>
  </div>
</div>
